import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import {
  AddressMain,
  CityField,
  CountryField,
  FnrAddress,
  Line1,
  Line2,
  StateField,
  StreetField,
  ZipField,
} from "UI/FnrAddress";
import FnrButton from "UI/FnrButton3";
import FnrFade from "UI/FnrFade";

const SFnrButton = styled(FnrButton)`
  height: 28.5px;
`;

/*
Expected `values` structure:

const [values, setValues] = useState({
  street: "123 Main St",
  city: "Tuskaloosa",
  state: "AL",
  zip: "12345",
  countryID: 1,
});

*/

const FnrAddressComplete = ({
  values,
  setValues,
  onUpdate,
  addr1,
  omitCountry,
  width,
  showSave,
  onSave,
  isSaving,
  label,
}) => {
  const updateValue = (key, value) => {
    if (onUpdate) {
      onUpdate();
    }
    setValues({
      ...values,
      [key]: value,
    });
  };

  const wrapperStyles = { boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)" };

  return (
    <Wrapper data-cy="FnrAddressComplete_Container" $width={width}>
      <FnrAddress style={wrapperStyles}>
        {!omitCountry && (
          <CountryField
            value={values.countryID}
            onChange={(id) => updateValue("countryID", id)}
          />
        )}
        <AddressMain>
          <Line1>
            <StreetField
              disabled={isSaving}
              label={label}
              value={values.street || values.addr1}
              onChange={(e) =>
                updateValue(addr1 ? "addr1" : "street", e.target.value)
              }
            />
            <FnrFade show={showSave && onSave} top={false} left>
              <SFnrButton
                loading={isSaving}
                color="green"
                size="small"
                onClick={onSave}
                preventDefault
              >
                Save
              </SFnrButton>
            </FnrFade>
          </Line1>
          <Line2>
            <CityField
              disabled={isSaving}
              value={values.city}
              onChange={(e) => updateValue("city", e.target.value)}
            />
            <StateField
              disabled={isSaving}
              value={values.state}
              onChange={(val) => updateValue("state", val)}
              countryID={values.countryID}
            />
            <ZipWrapper>
              <ZipField
                disabled={isSaving}
                value={values.zip}
                onChange={(e) => updateValue("zip", e.target.value)}
                countryID={values.countryID}
              />
            </ZipWrapper>
          </Line2>
        </AddressMain>
      </FnrAddress>
    </Wrapper>
  );
};

// FnrAddressComplete.name = "FnrAddressComplete";

const Wrapper = styled.div`
  max-width: 500px;
  ${({ $width }) => ($width ? `width: ${$width}px;` : "")}
`;

const ZipWrapper = styled.div`
  box-sizing: border-box;
  padding-right: 13px;
  flex-shrink: 0;
  width: 80px;
`;

export { FnrAddressComplete };
